import DashboardPage from "../containers/DashboardPage";


let reportRoutes = [{
  path: "/reports/dashboard", component: DashboardPage, exact: true
}];

export default reportRoutes;
